import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

// Material components
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// Shared layouts
import DashboardLayout from 'layouts/Dashboard';

// Custom components
//import Notifications from './components/Notifications';

//import Password from './components/Password';
//import ListObjectives from './components/ListObjectives';
//import BusinessHours from './components/BusinessHours';
//import ClientWeighing from './components/ClientWeighing';
import QuickViewIspView from './components/QuickViewIspView';
import UserLights from './components/UserLigths';
import QuickViewFullView from './components/QuickViewFullView';

import queryString from 'query-string';
import { getRouteObject } from '../../utils/fns/get-query-params';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';
// Component styles
const styles = theme => ({
    root: {
        "& .MuiPaper-root": {
            borderColor: '#fff'
        },
        "& .PortletHeader-root": {
            borderColor: '#fff !important'
        },
        //Custom Styles AP
        backgroundColor: '#e7e7e7',
        /*height: '100vh'*/
    }
});

class QuickViewIspLights extends Component {
    constructor(props) {
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.state = {
            tabIndex: 0,
            props: props,
            value: 0,
            profileId: sessionStorage.getItem('profile_id'),
            listHours: [1]
        }

    }

    componentDidMount() {
        const parsed = queryString.parse(this.props.location.search);
        let tab = parsed?.tab ?? 1
        if (isNaN(tab) || Number(tab) > 3 || Number(tab) < 1 ) {
            tab = 1
        }
        this.setState({value: parseInt(tab) - 1})
    }

    myCallback = (dataFromChild) => {
        
        this.setState({
            objectivesList: dataFromChild
        })
    }

    handleChange = (event, newValue) => {
        const URL = this.props.location.pathname
        
        this.props.history.push(getRouteObject(URL, {...queryString.parse(document.location.search), tab: newValue + 1}),{ Graph:1 })
    };

    render() {
        const { classes } = this.props;
        const {value, objectivesList, profileId, listHours} = this.state;
        var displayHours = false
        var displayWeighing = false
        if(listHours.includes(parseInt(profileId)) === true){
            displayHours = true
            //displayWeighing = true
        }
        const t = (this.props && this.props.t) ? this.props.t : (s => s)
        return (
            <DashboardLayout title={t('dashboard-layout.title.quickview-isp')} callbackFromParent={this.myCallback}>
                {objectivesList ?
                    <div className={classes.root} >
                        <AppBar position="static"  style={{ backgroundColor: '#333333' }}>
                            <Tabs value={value} onChange={this.handleChange}>
                                <Tab label={t('quickview-isp.tab.quickview')}/>
                                <Tab label={t('quickview-isp.tab.quickview-compact')}/>
                                <Tab label={t('quickview-isp.tab.traffic-light')}/>
                            </Tabs>
                        </AppBar>
                        
                        { value == 0 ?
                            <QuickViewFullView/>
                        : value == 1 ? 
                            <QuickViewIspView/>  
                        : value == 2 ? 
                            <UserLights />    
                        : null }
                    </div>
                :null}
            </DashboardLayout>
        );
    }
}

QuickViewIspLights.propTypes = {
    classes: PropTypes.object.isRequired
};

export default compose(withStyles(styles), withTranslation())(QuickViewIspLights);
